<app-banner></app-banner>
<app-search-form (search)="handleSearch($event)"></app-search-form>
<app-services></app-services>
<div class="section bg-secondary-1">
  <div class="container">
    <app-why-us></app-why-us>
    <app-counter></app-counter>
  </div>
</div>
<div class="section pb-0 bg-gray"></div>
<div class="section section-padding bg-gray">
  <div class="container">
    <div class="section-title centered">
      <span class="subtitle">What We do</span>
      <h3 class="title">Our Services</h3>
    </div>
    <app-services-image></app-services-image>
    <div class="margin-negative">
      <div class="row">
        <div class="col-lg-6">
          <!-- <app-newsletter></app-newsletter> -->
           <app-testimonials></app-testimonials>
        </div>
        <div class="col-lg-6">
          <app-clients></app-clients>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="section section-padding"></div>
<div 
  class="whatsapp-floater"
  [ngStyle]="{ 'bottom': isConsultationVisible ? '260px' : '70px' }"
>
  <a target="_blank" href="https://wa.me/message/SXXICSCAMLK6H1">
    <i class="fab fa-whatsapp"></i>
  </a>
</div>
<div class="consultation">
  <div 
    *ngIf="!isConsultationVisible" 
    class="sigma_info-title desktop-only"
    (click)="openConsultation()"
  >
    <span class="sigma_info-icon">
      <i class="fal fa-headphones-alt"></i>
    </span>
  </div>

  <div 
    class="sigma_info-title mobile-only"
    (click)="goToConsultationService()"
  >
    <span class="sigma_info-icon">
      <i class="fal fa-user-md"></i>
    </span>
  </div>

  <div *ngIf="isConsultationVisible" class="desktop-only">
    <app-medical-consultation></app-medical-consultation>
    <button class="close-btn" (click)="closeConsultation()">
      <i class="fal fa-times"></i>
    </button>
  </div>
</div>
